export interface Column {
  key: string;
  name: string;
  align: 'left' | 'right';
  type: 'number' | 'date' | 'currency';
}

export const DEFAULT_COLUMNS: Column[] = [
  { key: 'units', name: 'Units', align: 'right', type: 'number' },
  { key: 'proceeds', name: 'Proceeds', align: 'right', type: 'currency' },
  { key: 'costBasis', name: 'Cost Basis', align: 'right', type: 'currency' },
  { key: 'shortTerm', name: 'Short Term G/L', align: 'right', type: 'currency' },
  { key: 'longTerm', name: 'Long Term G/L', align: 'right', type: 'currency' },
  { key: 'total', name: 'Total G/L', align: 'right', type: 'currency' },
];

export const TAX_LOT_COLUMNS: Column[] = [
  { key: 'acquiredDate', name: 'Acquired Date', align: 'left', type: 'date' },
  { key: 'sellDate', name: 'Closed Date', align: 'left', type: 'date' },
  ...DEFAULT_COLUMNS,
];
